import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("@App:token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (String(error?.code)?.match("ERR_NETWORK")) {
      console.error("Erro de rede ou CORS", error);
      // localStorage.removeItem("@App:user");
      // localStorage.removeItem("@App:token");
      // localStorage.clear();
      // window.location.replace('/logout');
    }

    return Promise.reject(error);
  },
);
